<template>
  <el-table :data="gunDataTable" stripe style="width: 100%" ref="gunDataTable" border v-loading="listLoading">
    <!--                <af-table-column type="selection" width="30"></af-table-column>-->
    <af-table-column prop="gunCode" width="180" :label="$t('siteMonitor.gunCode')"></af-table-column>
    <af-table-column prop="gunNum" width="70" :label="$t('qiang-kou-hao-0')"></af-table-column>
    <af-table-column prop="gunName" width="120" :label="$t('qiang-ming-cheng-0')" ></af-table-column>
    <af-table-column prop="pileCode" :label="$t('deviceControl.pileId')"></af-table-column>
    <af-table-column prop="stationName" width="180" :label="$t('suo-shu-chang-zhan')"></af-table-column>
    <af-table-column prop="operatorName" width="200" :label="$t('suo-shu-yun-ying-shang-0')"></af-table-column>
    <af-table-column width="120" :label="$t('qiang-shi-fou-zai-xian')">
      <template slot-scope="{row}">
        <div v-if="row.gunConnectionState">
          <el-tag :type="row.gunConnectionState.code | gunConnectionStateFilter">
            {{ row.gunConnectionState.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column width="120" :label="$t('deviceControl.GunWorkingStatus')">
      <template slot-scope="{row}">
        <div v-if="row.state">
          <el-tag :type="row.state.code | stateFilter">
            {{ row.state.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column width="120" :label="$t('deviceControl.CarConnectionStatus')">
      <template slot-scope="{row}">
        <div v-if="row.carConnectionState">
          <el-tag :type="row.carConnectionState.code | carConnectionStateFilter" size="100">
            {{ row.carConnectionState.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column width="120" :label="$t('di-suo-zhuang-tai')">
      <template slot-scope="{row}">
        <div v-if="row.floorLockState">
          <el-tag :type="row.floorLockState.code | floorLockStateFilter" size="100">
            {{ row.floorLockState.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column prop="floorLockQua" width="100" :label="$t('di-suo-dian-liang')"></af-table-column>
    <af-table-column width="120" :label="$t('di-suo-gao-jing')">
      <template slot-scope="{row}">
        <div v-if="row.floorLockAlarm">
          <el-tag :type="row.floorLockAlarm.code | floorLockAlarmFilter" size="100">
            {{ row.floorLockAlarm.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column width="120" :label="$t('che-wei-zhuang-tai')">
      <template slot-scope="{row}">
        <div v-if="row.parkLotState">
          <el-tag :type="row.parkLotState.code | parkLotStateFilter" size="100">
            {{ row.parkLotState.message }}
          </el-tag>
        </div>
      </template>
    </af-table-column>
    <af-table-column :label="$t('deviceControl.operation')" width="240px">
      <template slot-scope="scope">
        <el-button size="mini" plain @click="gunDetail(scope.$index, scope.row)">{{ $t('xiang-qing') }}</el-button>
        <el-button size="mini" @click="gunEdit(scope.$index, scope.row)"
                   v-if="checkPermission(['bee:res:gun:saveOrUpdateGunEdit'])">{{ $t('alaramMonitor.edit') }}
        </el-button>
        <el-button size="mini" type="danger" @click="gunDelete(scope.$index, scope.row)"
                   v-if=" checkPermission(['bee:res:gun:deleteGun'])">{{ $t('deviceControl.delete') }}
        </el-button>
      </template>
    </af-table-column>
  </el-table>
</template>

<script>
  export default {
    name: "list",
    data(){
      return{

      }
    },
    props:{
      gunDataTable:{},
      listLoading:false,
    },
    methods:{
      gunDetail(index,row){
        this.$emit("gunDetail",index,row)
      },
      gunEdit(index,row){
        this.$emit("gunEdit",index,row)
      },
      gunDelete(index,row){
        this.$emit("gunDelete",index,row)
      }
    },
    filters: {
      stateFilter(state) {
        const statusMap = {
          '-1': 'info',  // 离线
          0: 'success',  // 空闲
          1: 'warning',     //启动充电中
          2: 'warning',    //充电进行中
          3: 'primary',   //充电结束
          4: 'danger',   //启动充电失败
          5: 'danger',   //预约充电中
          6: 'info'    //充电终端故障
        }
        return statusMap[state]
      },
      gunConnectionStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 离线
          1: 'success',     //在线
        }
        return statusMap[state]
      },
      carConnectionStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 断开
          1: 'success',     //连接
          2: 'success'     //半连接
        }
        return statusMap[state]
      },
      floorLockStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 未到位状态
          85: 'success',     //升锁到位状态
          255: 'success'     //降锁到位状态
        }
        return statusMap[state]
      },
      floorLockAlarmFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'success',  // 正常无报警
          85: 'info',     //摇臂升降异常
          255: 'info'     //待机状态摇臂破坏
        }
        return statusMap[state]
      },
      parkLotStateFilter(state) {
        if (state == null) {
          state = 1;
        }
        const statusMap = {
          0: 'info',  // 无车辆
          255: 'success'     //停放车辆
        }
        return statusMap[state]
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/module/resourceCenter/page/charginggunManager/list.vue